import React, { useCallback, useEffect, useState } from 'react';

import {
  Box,
  Button,
  Grid,
  Link,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';

import WhatsappSrc from '../../../../assets/img/whatsapp.svg';
// import WhatsappSrc from '../../../../assets/img/whatsapp.png';
import Dropzone from '../../../../components/Dropzone/Dropzone.component';
import SharedDialog from '../../../../components/SharedDialog/SharedDialog.component';
import { appConfig } from '../../../../config/app';
import { IncidentsDocumentsTypes } from '../../../../constants/incidents.constant';
import { useSinisterDataContext } from '../../../../context/sinister/sinister.provider';

const InsideDocumentationElement = ({ onAction, image, buttonLabel }: any) => (
  <>
    <img src={image} alt="denuncia" />
    <Box my={3}>
      <Button variant="contained" color="primary" onClick={onAction}>
        {buttonLabel}
      </Button>
    </Box>
  </>
);

const DocumentPhoto = ({ double, document, handlingNext, preview }: any) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));

  const [complaintImage, setComplaintImage] = useState('');
  const [complaintImage2, setComplaintImage2] = useState('');
  const [hasTwo, setHasTwo] = useState(!!preview?.['photo[1]']);

  useEffect(() => {
    setHasTwo(!!preview?.['photo[1]']);
  }, [preview]);

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Box my={2}>
            <Typography variant="h6" color="textPrimary">
              {document.title}
            </Typography>
          </Box>
          <Box mb={3}>
            {!matches && (
              <Typography variant="body1">
                Revisá que no esté borrosa, cortada, y ni oscura.
              </Typography>
            )}
          </Box>
        </Grid>
        <Grid item xs={12} md={12}>
          <Grid container justify="center" alignItems="center">
            <Grid item xs={hasTwo ? 6 : 12}>
              <Box m={2}>
                <Dropzone
                  onChange={(file: string) => setComplaintImage(file)}
                  onNext={(skipped: boolean) =>
                    handlingNext(
                      double
                        ? [complaintImage, complaintImage2]
                        : complaintImage,
                      skipped
                    )
                  }
                  preview={preview?.['photo[0]']}
                  hideContinueBtn={hasTwo}
                  optional
                  getFile
                >
                  <InsideDocumentationElement
                    image={document.img}
                    buttonLabel={document.button}
                  />
                </Dropzone>
              </Box>
            </Grid>

            {hasTwo ? (
              <>
                <Grid item xs={hasTwo ? 6 : 12}>
                  <Box m={2}>
                    <Dropzone
                      onChange={(file: string) => setComplaintImage2(file)}
                      onNext={(skipped: boolean) =>
                        handlingNext(
                          double
                            ? [complaintImage, complaintImage2]
                            : complaintImage,
                          skipped
                        )
                      }
                      preview={preview?.['photo[1]']}
                      hideContinueBtn={true}
                      optional
                      getFile
                    >
                      <InsideDocumentationElement
                        image={document.img}
                        buttonLabel={document.button}
                      />
                    </Dropzone>
                  </Box>
                </Grid>
                <Box textAlign="center" m={2}>
                  {/* Fix dos fotos en null en validar */}
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={() =>
                      handlingNext(
                        double
                          ? [complaintImage, complaintImage2]
                          : complaintImage,
                        false
                      )
                    }
                  >
                    Continuar
                  </Button>
                </Box>
              </>
            ) : null}
          </Grid>
        </Grid>
        {double && (
          <Grid container justify="center" alignItems="center">
            <Grid item xs={6}>
              <Box textAlign="center">
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => setHasTwo(!hasTwo)}
                  disabled={hasTwo}
                >
                  + Agregar otra fotografía
                </Button>
              </Box>
            </Grid>
          </Grid>
        )}
      </Grid>
    </>
  );
};

const InjuredPersonsDocumentationPhotos = () => {
  const {
    nextStep,
    sinister_body,
    image_preview,
    updloadPhotos,
    success,
    errors,
  } = useSinisterDataContext();
  const [open, setOpen] = useState(false);

  const [documents] = useState(sinister_body.crash?.involved?.documents);
  const [currentDocument, setCurrentDocument] = useState(0);
  const [preview, setPreview] = useState(
    image_preview.find(
      (prev: any) =>
        prev?.type === sinister_body.incident_type &&
        prev.photo_type === documents[currentDocument]?.type &&
        prev.side === documents[currentDocument].side
    )
  );

  const handlingNextStep = useCallback(() => {
    setCurrentDocument((currDoc) => {
      if (currDoc === documents.length - 1) {
        nextStep();
        return currDoc;
      } else {
        setPreview(
          image_preview.find(
            (prev: any) =>
              prev?.type === sinister_body.incident_type &&
              prev.photo_type === documents[currDoc + 1]?.type &&
              prev.side === documents[currDoc + 1].side
          )
        );
        return currDoc + 1;
      }
    });
  }, [nextStep, documents, image_preview, sinister_body]);

  const handlingNext = (
    photos: string[] | string,
    skipped: boolean = false
  ) => {
    if (!skipped) {
      const { incident_type, vehicle_id } = sinister_body;
      const formData: any = {};
      formData['type'] = incident_type;
      formData['vehicle_id'] = vehicle_id;
      formData['photo_type'] = documents[currentDocument]?.type;
      formData['side'] = documents[currentDocument].side;

      if (Array.isArray(photos)) {
        photos.forEach((photo, index) => {
          formData[`photo[${index}]`] = photo;
        });
      } else {
        formData[`photo[0]`] = photos;
      }

      updloadPhotos(formData);
    } else {
      handlingNextStep();
    }
  };

  useEffect(() => {
    if (success.photo) {
      handlingNextStep();
    }
  }, [success, handlingNextStep]);

  useEffect(() => {
    if (errors.photo) {
      setOpen(true);
    }
  }, [errors]);

  useEffect(() => {
    if (documents.length === 0) {
      nextStep();
    }
  }, [documents.length, nextStep]);

  return (
    <>
      <SharedDialog
        open={open}
        onClose={() => setOpen(false)}
        content={
          <Box>
            <Box mb={2}>
              <Typography variant="h6">
                ¡Lo sentimos! no pudimos procesar correctamente tus fotos
              </Typography>
              <Typography variant="body2">
                Podés reintentar en unos instantes o comunicarte con nosotros
                por Whatsapp para cargar tu denuncia.
              </Typography>
            </Box>
          </Box>
        }
        actions={
          <Grid container justify="flex-end">
            <Grid item xs={12} sm={6}>
              <Box m={2} display="flex" alignItems="center">
                <Link
                  href={appConfig?.WHATSAPP_LINK}
                  rel="noopener"
                  target="_blank"
                >
                  <Button variant="outlined" fullWidth color="secondary">
                    <img
                      src={WhatsappSrc}
                      alt="Whatsapp"
                      style={{ marginLeft: '15px' }}
                    />
                    <Typography display="inline">
                      Comunicarme vía Whatsapp
                    </Typography>
                  </Button>
                </Link>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box m={2}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={() => setOpen(false)}
                >
                  Entendido
                </Button>
              </Box>
            </Grid>
          </Grid>
        }
      ></SharedDialog>

      {documents.length > 0 && (
        <DocumentPhoto
          document={documents[currentDocument]}
          double={
            documents
              ? documents[currentDocument]?.type ===
                IncidentsDocumentsTypes.POLICE_COMPLAINT
              : false
          }
          handlingNext={handlingNext}
          preview={preview}
        />
      )}
    </>
  );
};

export default InjuredPersonsDocumentationPhotos;
